import get from 'lodash/get';
import head from 'lodash/head';
import { all, put, select, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { getFileStatesRequest } from '@savgroup-front-common/core/api/Workflow/getFileStatesQuery';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { onFileStateChanged } from './actionCreators';
import { GET_FILE_STATES } from './actionTypes';
import { selectLatestFileStateByFileId } from './selectors';

function isFileStateChanged({ oldLatestFileState, newLatestFileState }) {
  return (
    get(oldLatestFileState, ['state', 'name'], undefined) !== undefined &&
    get(oldLatestFileState, ['state', 'name']) !==
      get(newLatestFileState, ['state', 'name'])
  );
}

export function* loadFileStatesWorker({ payload: fileId }) {
  const oldLatestFileState = yield select(
    selectLatestFileStateByFileId,
    fileId,
  );

  if (!fileId) {
    yield put(GET_FILE_STATES.end(fileId));

    return;
  }

  const response = yield executeSagaRequest(
    GET_FILE_STATES,
    getFileStatesRequest({ fileId }),
    {
      fileId,
      indexer: fileId,
    },
  );

  const newLatestFileState = head(
    get(
      response,
      ['payload', 'value'],
      [
        {
          state: {},
          module: {},
        },
      ],
    ),
  ) || {
    state: {},
    module: {},
  };

  if (isFileStateChanged({ oldLatestFileState, newLatestFileState })) {
    yield put(
      onFileStateChanged({
        fileId,
      }),
    );
  }

  yield put(GET_FILE_STATES.end(fileId));
}
function* loadFileStatesWatcher() {
  yield takeEvery(GET_FILE_STATES.BASE, loadFileStatesWorker);
}

export default function* workflowSaga() {
  try {
    yield all([loadFileStatesWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
